import { useLayoutEffect, useRef, type ReactNode, type RefObject } from 'react';
import { createPortal } from 'react-dom';

export default function ChatBotPopover({ anchorRef, theme, label, children }: {
  anchorRef: RefObject<HTMLButtonElement | null>;
  theme: string;
  label: string;
  children: ReactNode;
}) {
  const menuRef = useRef<HTMLDivElement>(null);
  useLayoutEffect(() => {
    const menu = menuRef.current;
    const anchor = anchorRef.current;
    if (!menu || !anchor) return;
    const bounds = anchor.getBoundingClientRect();
    const width = Math.min(360, window.innerWidth - 16);
    const below = window.innerHeight - bounds.bottom - 12;
    const above = bounds.top - 12;
    const openAbove = below < 180 && above > below;
    Object.assign(menu.style, {
      width: `${width}px`,
      left: `${Math.max(8, Math.min(bounds.right - width, window.innerWidth - width - 8))}px`,
      right: 'auto',
      top: openAbove ? 'auto' : `${bounds.bottom + 4}px`,
      bottom: openAbove ? `${window.innerHeight - bounds.top + 4}px` : 'auto',
      maxHeight: `${Math.max(0, Math.min(420, openAbove ? above : below))}px`,
    });
  }, [anchorRef]);

  return createPortal(
    <div className="chat-sidebar-theme" data-theme={theme}>
      <div
        ref={menuRef}
        data-ui="chat-sidebar-thread-bot-menu"
        role="region"
        aria-label={label}
        style={{ position: 'fixed', zIndex: 99990 }}
        className="bg-black/95 text-white backdrop-blur-xl rounded-2xl shadow-inner-glow shadow-inner-glow-gray-500-md border-none"
      >
        {children}
      </div>
    </div>,
    document.body,
  );
}
